import { render } from "./messagesGameManual.vue?vue&type=template&id=3df6c8e0"
import script from "./messagesGameManual.vue?vue&type=script&lang=js"
export * from "./messagesGameManual.vue?vue&type=script&lang=js"

import "./messagesGameManual.vue?vue&type=style&index=0&id=3df6c8e0&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__